import { h } from 'preact';
import { css } from 'react-emotion';
import { TipShow, TipPosition } from '../../../typing/enums';
import { withContext } from '../../../common/context';
import { isTouch } from '../../../utils/touch';
import { getRgbaColor } from '../../../utils/color';
import { FlexCenterStretched } from '../../../utils/emotion';

const ZoomTip = props => {
  const config = props.context.config;
  const zoomPropsShowTip = config.selectZoomPropsShowTip();
  const shouldRenderTip = !(
    zoomPropsShowTip === TipShow.NEVER ||
    (isTouch && zoomPropsShowTip === TipShow.DESKTOP) ||
    (!isTouch && zoomPropsShowTip === TipShow.TOUCH)
  );

  const msgCls = css({
    backgroundColor: getRgbaColor(config.selectTipPropsColor(), config.selectTipPropsOpacity()),
    color: config.selectTipPropsTextColor(),
    padding: '8px 12px',
    borderRadius: config.selectTipPropsRadius(),
    margin: isTouch ? '12px' : '46px', // Leave room for multi-zoom buttons
    fontSize: '1.3em'
  });

  return shouldRenderTip ? (
    <FlexCenterStretched
      data-test="zoom-media-icon-wrap"
      absolute
      className={css({
        flexDirection: 'column',
        opacity: props.isZoomed ? 0 : 1,
        transition: 'opacity .25s ease-in',
        borderRadius: config.selectTipPropsRadius(),
        justifyContent:
          config.selectZoomPropsTipPosition() === TipPosition.BOTTOM
            ? 'flex-end'
            : config.selectZoomPropsTipPosition() === TipPosition.TOP
              ? 'flex-start'
              : 'center'
      })}
    >
      <div className={msgCls} data-test="tip-wrap">
        {isTouch ? config.selectZoomPropsTipTouchText() : config.selectZoomPropsTipText()}
      </div>
    </FlexCenterStretched>
  ) : null;
};

export default withContext(ZoomTip);
